import api from "@/api";

export const dashboardService = {
  async getResumo(start, end, restaurantesSelecionados = null) {
    const { data } = await api.post("/cartoes/dashboard-resumo", {
      start,
      end,
      restaurantesSelecionados,
    });
    return data;
  },

  async getRestaurantes() {
    const { data } = await api.get("/restaurantes");
    return data;
  },

  async getResumoDia(dia, restaurantesSelecionados = null) {
    const { data } = await api.post("/cartoes/dashboard-dia", {
      dia,
      restaurantesSelecionados,
    });
    return data;
  },
};
